import {useState, useEffect} from "react";
import {useParams, useNavigate, useLocation} from "react-router-dom";
import {
  Button,
  Container,
  Grid,
  Stack,
  Typography,
  TextField,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Paper,
  Avatar
} from "@mui/material";
// components
import Page from "src/components/Page";
import {alert} from "src/services/alert";
import {asyncRequest} from "src/services/network";
import {Wrapper} from "./KefuChat.styled";
import socketIOClient from "socket.io-client";
import {BASE_URL, IMG_BASE_URL, MESSAGE_TYPES} from "src/config/constants";
import {nanoid} from "@reduxjs/toolkit";
import timeline from "src/utils/timeline";
import iconLogo from "src/assets/jzlc_logo.png";
import {useDispatch, useSelector} from "react-redux";
import {addMessages, setChatItems, setMessages, setTarget} from "src/store/reducers/message";
import SocketIO from "src/services/socket.service";

const ENDPOINT = BASE_URL;

let socket;
let interval;

export default function KefuChat() {
  const dispatch = useDispatch()
  const {messages, target, chatItems} = useSelector(state => state.message)
  const navigate = useNavigate();

  const [form, setForm] = useState({});
  // const [chatItems, setChatItems] = useState([]);
  // const [target, setTarget] = useState(null);
  const [msg, setMsg] = useState("");
  // const [messages, setMessages] = useState([]);

  const [filter, setFilter] = useState({
    page: 0,
    size: 100,
    uid: 0,
  });

  useEffect(() => {
    SocketIO.init();
    getChatItems();
  }, []);

  useEffect(() => {
    interval = setInterval(() => {
      getChatItems();
    }, 60000)
    return () => {
      clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    return;
    socket = socketIOClient(ENDPOINT);
    socket.on("connect", (data) => {
      console.log("connected");
      socket.emit("admin");
    });

    socket.on("private", (data) => {
      console.log("privte", data);
      const {message, chatItem} = data;
      // const idx = chatItems.findIndex((ci) => ci.uid === message.uid);
      // if (idx > -1) {
      //   const item = chatItems.splice(idx, 1);
      //   chatItems.unshift(item);
      // } else {
      //   chatItems.push(chatItem);
      // }

      // setChatItems([...chatItems]);

      console.log(target, message)

      if (!!target && message.uid == target.user.uid) {
        // setMessages([
        //   {
        //     ...message,
        //     info: JSON.parse(message.info),
        //   },
        //   ...messages
        // ]);

        dispatch(addMessages({
          ...message,
          info: JSON.parse(message.info)
        }));
      }
    });

    socket.on("disconnect", (data) => {
      console.log("disconnected");
    });

    return () => {
      socket.close();
    };
  }, []);

  async function getChatItems() {
    const {data, msg} = await asyncRequest({
      method: "get",
      path: "/chat/item/list",
    });

    // alert(msg, "success");
    dispatch(setChatItems(data));
  }

  // message
  function handleSendMsg() {
    if (!msg) return;

    SocketIO.sendPrivateMsg("private-admin", {
      type: MESSAGE_TYPES.TEXT,
      mid: nanoid(),
      info: msg,
      to: target.user.uid,
    });

    setMsg("");
  }

  useEffect(() => {
    if (!target) return;
    if (target.user.uid === filter.uid) return;
    setFilter({
      ...filter,
      page: 0,
      uid: target.user.uid,
    });
  }, [target]);

  useEffect(() => {
    if (!filter.uid) return;
    getMessages();
  }, [filter]);

  async function getMessages() {
    const {data, msg} = await asyncRequest({
      path: "/chat/message/list",
      data: {
        ...filter,
        uid: target.user.uid,
      },
    });

    dispatch(setMessages(
      data.map((d) => ({
        ...d,
        info: JSON.parse(d.info),
      }))
    ))
    // setMessages(
    //   data.map((d) => ({
    //     ...d,
    //     info: JSON.parse(d.info),
    //   }))
    // );
  }

  function renderItems() {
    return messages.map((message) => {
      const {info, isAdmin, createdAt} = message;

      const name = isAdmin ? "客服" : target.user.nickname || target.user.uid;
      const time = timeline(createdAt);
      let avatar;
      if (isAdmin) {
        avatar = iconLogo
      } else if (target.user.avatar && target.user.avatar != '' && target.user.avatar != 'null') {
        avatar = `${IMG_BASE_URL}${target.user.avatar}?w=60`;
      } else {
        avatar = `${process.env.PUBLIC_URL}/static/mock-images/avatars/avatar_default.jpg?w=60`;
      }
      return (
        <>
          {isAdmin ? (
            <div className="k16872509602488">
              <div className="k16872509602489">
                <div className="k168725111718116">
                  <span className="k168725214918166">{time}</span>
                  <span className="k168725112465417">{name}</span>
                </div>
                <div className="k168725096024810">
                  <span className="k168725096024811">{info.text}</span>
                </div>
              </div>
              <Avatar src={avatar}/>
            </div>
          ) : (
            <div className="k168725122257418">
              <Avatar src={avatar}/>
              <div className="k168725122257419">
                <div className="k168725122257420">
                  <span className="k168725122257421">{name}</span>
                  <span className="k168725225222667">{time}</span>
                </div>
                <div className="k168725122257422">
                  <span className="k168725122257423">{info.text}</span>
                </div>
              </div>
            </div>
          )}
        </>
      );
    });
  }

  return (
    <Page title="客服聊天">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            客服聊天
          </Typography>
        </Stack>

        <Wrapper className="k16872421728962">
          <div className="k16872423031813">
            <div className="k168724855532724">
              <div className="k168724857795225">
                <img className="k168724875378227"
                     src="https://media.quhua.fun/uploads/811510847/CrMAOZqA5uLunMzunq65/6fdb9b0a0c5a96226eb8e833c.png"/>

                <span className="k168724858459326">聊天列表</span>
              </div>
              <div className="k16872526335851">
                <div className="k168724926627229">
                  {chatItems.map((item, index) => (
                    <div
                      className={`k168724967226837 ${target && item.uid == target.uid ? 'active' : ''}`}
                      key={index}
                      onClick={() => {
                        dispatch(setTarget(item));
                      }}
                    >
                      {(item.user && item.user.avatar && item.user.avatar != '' && item.user.avatar != 'null') ? (
                        <Avatar src={`${IMG_BASE_URL}${item.user.avatar}?w=60`}/>) : (
                        <Avatar src={`${process.env.PUBLIC_URL}/static/mock-images/avatars/avatar_default.jpg?w=60`}/>)}
                      <div className="k168724976549239">
                        <div className="k168724971355738">
                          <span
                            className="k168724950079733">{item.user ? (item.user.nickname || item.user.uid) : "未知"}</span>
                          {/* <span className="k168724956248735">{item.createdAt}</span> */}
                        </div>
                        <span className="k168724977207640">{item.latestMsg}</span>
                      </div>
                      {item.unread ? (<div>未读{item.unread}</div>) : null}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {!!target && (
              <div className="k16872504636680">
                <div className="k16872509171916">
                  <div className="k16872505232561">
                    <div className="k16872505535012">
                      <span className="k16872505681403">{target.user.nickname || target.user.uid}</span>
                    </div>
                    <div className="k16872507361824"></div>
                  </div>
                </div>
                <div className="k16872509276757">
                  <div className="k168725188100454">{renderItems()}</div>
                </div>
                <div className="k168725153346626">
                  <div className="k168725160955827">
                    <img className="k168725171569928"
                         src="https://media.quhua.fun/uploads/811510847/CrMAOZqA5uLunMzunq65/6fdb9b0a0c5a96226eb8e8340.png"/>
                    <img className="k168725173443329"
                         src="https://media.quhua.fun/uploads/811510847/CrMAOZqA5uLunMzunq65/6fdb9b0a0c5a96226eb8e8341.png"/>
                  </div>
                  <div className="k168725190866955">
                    <textarea value={msg} onChange={(e) => setMsg(e.target.value)} className="k168725192714256"
                              placeholder="请输入消息，按Enter键 或 点击发送按钮发送"></textarea>
                  </div>
                  <div className="k168725202767064">
                    <button className="k168725207355865" onClick={handleSendMsg}>
                      发送
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Wrapper>
      </Container>
    </Page>
  );
}
